export default "__VITE_ASSET__3ab2476d__"